import React from "react"
import accessibleSvg from "src/utils/accessibleSvg"

export default accessibleSvg(({ children, ...props }) => (
  <svg
    fill="currentColor"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
    <path
      id="Lightning_Bolt"
      data-name="Lightning Bolt"
      fillRule="evenodd"
      d="M50,100c49.614,0,50-22.386,50-50S99.614,0,50,0,0,22.386,0,50,0.386,100,50,100ZM48.08,70.223V53.37a1.442,1.442,0,0,0-1.44-1.444H35.483l14.15-21.29a1.919,1.919,0,0,1,1.6-.858h0.69V46.63a1.442,1.442,0,0,0,1.44,1.444H64.517l-14.15,21.29a1.92,1.92,0,0,1-1.6.858H48.08ZM48.77,76a7.674,7.674,0,0,0,6.39-3.43L73.752,44.595A1.482,1.482,0,0,0,74,43.774h0A1.476,1.476,0,0,0,72.526,42.3H57.68V25.445A1.442,1.442,0,0,0,56.24,24H51.23a7.674,7.674,0,0,0-6.39,3.43L26.247,55.405a1.484,1.484,0,0,0-.247.821h0A1.476,1.476,0,0,0,27.474,57.7H42.32V74.556A1.442,1.442,0,0,0,43.76,76h5.01Z"
    />
  </svg>
))
